'use client' // Error boundaries must be Client Components

import { reportError, TrackingAction } from '@/lib/error/tracking'
import { useEffect } from 'react'

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(
      TrackingAction.GLOBAL_ERROR,
      error.stack || error.message,
    );
  }, [error]);

  return (
    <div className="flex items-center justify-center h-screen">
      <h2>Something went wrong!</h2>
    </div>
  );
}